export const objectiveForm: any = {
  id: "",
  username: "",
  email: "",
  avatar: "",
  readaccess: "",
};
